<div class="card section">
  <div class="card-body">
    <div class="row">
      <div class="col-1 pt-2">
        <h6>{{ number ?? "#" }}</h6>
      </div>
      <div class="col-9 d-flex pt-2">
        <div class="pr-1">
          <span [innerHTML]="labelHtml | placeholderHighlight"></span>
          <br />
          <div *ngIf="(!moreInfo && isActiveStatus) || !isActiveStatus">
            <span *ngIf="schedule; else noSchedule">
              <mat-label>Last Completed Date:</mat-label>
              <b
                class="date"
                [ngClass]="{ 'expired-date': warning && isActiveStatus }"
                >&nbsp;<mat-label
                  [innerHTML]="dateValue1 | date: 'M/d/yyyy'"
                ></mat-label
                >&nbsp;</b
              >
              <mat-label>Next Inspection Due Date:</mat-label>
              <b
                class="date"
                [ngClass]="{ 'expired-date': warning && isActiveStatus }"
                >&nbsp;<mat-label
                  [innerHTML]="dateValue2 | date: 'M/d/yyyy'"
                ></mat-label
                >&nbsp;</b
              >
              <span *ngIf="dateValue3">
                <mat-label>Extended Date:</mat-label>
                <b
                  class="date"
                  [ngClass]="{ 'expired-date': warning && isActiveStatus }"
                  >&nbsp;<mat-label
                    [innerHTML]="dateValue3 | date: 'M/d/yyyy'"
                  ></mat-label
                ></b>
              </span>
            </span>
            <ng-template #noSchedule>
              <b *ngIf="isActiveStatus" class="red">Schedule Not Found!</b>
            </ng-template>
          </div>
          <div *ngIf="moreInfo && isActiveStatus" class="pr-1 bold color-red">
            <b class="red">{{ moreInfo }}</b>
          </div>
        </div>
      </div>

      <div class="col-2 d-flex flex-row justify-content-end align-items-center">
        <mat-checkbox-with-roles
          labelPosition="before"
          [checked]="checked"
          [disabled]="disabled"
          (change)="checkboxChanged($event)"
          color="primary"
          [roleCodes]="roleCodes"
          [user]="user"
          [warning]="moreInfo ?? ''"
          [date]="date"
        >
        </mat-checkbox-with-roles>
      </div>
    </div>
  </div>
</div>
